/*
 *             Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
import _0x36224c from'../../descriptor.js';class CommentThreadAddedCommentDescriptor extends _0x36224c{static['toJSON'](_0xdf9298){var _0x45ada2;return{'commentId':_0xdf9298['commentId'],'createdAt':null===(_0x45ada2=_0xdf9298['createdAt'])||void 0x0===_0x45ada2?void 0x0:_0x45ada2['toISOString']()};}static['fromJSON'](_0x39ff3f){return{'commentId':_0x39ff3f['commentId'],'createdAt':new Date(_0x39ff3f['createdAt'])};}}CommentThreadAddedCommentDescriptor['DESCRIPTOR_NAME']='CommentThreadAddedCommentDescriptor',CommentThreadAddedCommentDescriptor['DESCRIPTOR']={'fields':{'commentId':{'id':0x1,'type':'string'},'createdAt':{'id':0x2,'type':'string'}}};export default CommentThreadAddedCommentDescriptor;